import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ErrorMessageComponent } from './error-message/error-message.component';
import { SuccessMessageComponent } from './success-message/success-message.component';
@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [ErrorMessageComponent,
        SuccessMessageComponent],
    exports: [ErrorMessageComponent,
        SuccessMessageComponent]
})
export class MessageDisplayModule { }
